import { cn } from "@gettactic/helpers";

interface NotificationDotProps {
  className?: string;
}

export const NotificationDot: React.FC<NotificationDotProps> = ({
  className
}) => (
  <span
    className={cn(
      "absolute h-2 w-2 rounded-full bg-red-500",
      "animate-pulse",
      className
    )}
  />
);
